import React from 'react'
import { Row, Col } from 'antd';
import RecordInfo from './RecordInfo'

const MyRecordView = ({keycloak, language}) => {
    document.body.style.setProperty("background", "#fff", "important")
    return (
        <>
            <Row>
                <Col span={24}>
                    <section className="my-record">
                        <RecordInfo keycloak={keycloak} language={language} />
                    </section>
                </Col>
            </Row>
        </>
    )
}

export default MyRecordView